import script from "./MGSheetSlide.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGSheetSlide.vue?vue&type=script&setup=true&lang=ts"

import "./MGSheetSlide.vue?vue&type=style&index=0&id=15181c33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15181c33"]])

export default __exports__